import { InternalServerErrorException } from "@akina/infra";

export const uploadFileToS3 = async (presignedUrl: string, file: File, isPublic = false) => {
  try {
    const headers = new Headers({ "Content-Type": file.type });
    if (isPublic) {
      headers.append("x-amz-acl", "public-read");
    }
    await fetch(presignedUrl, {
      method: "PUT",
      headers: headers,
      body: file,
    });
  } catch (e) {
    throw new InternalServerErrorException({
      message: `Internal Server Error on S3 Upload for ${presignedUrl}`,
      stack: `uploadFileToS3:${presignedUrl}, isPublic=${isPublic}, ${e instanceof Error ? e.toString() : ""}`,
    });
  }
};
